import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useEffect, useState } from "react";
import useRefresh from "../hooks/useRefresh";

function RequiredAuth() {
	const { auth, setAuth } = useAuth();
	const refresh = useRefresh();

	// Extract token from localStorage initially
	const [activeToken, setActiveToken] = useState(() => {
		return localStorage.getItem("accessToken");
	});
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const validateAndRefreshToken = async () => {
			try {
				// If no auth token, try to refresh
				if (!auth?.accessToken || !activeToken) {
					const newAccessToken = await refresh();
					console.log(newAccessToken);

					if (newAccessToken) {
						setActiveToken(newAccessToken);
						localStorage.setItem("accessToken", newAccessToken);
						setAuth((prev) => ({
							...prev,
							accessToken: newAccessToken,
						}));
					} else {
						// If refresh fails or no token, clear state
						setActiveToken(null);
						localStorage.removeItem("accessToken");
					}
				} else {
					// If auth token exists, sync with localStorage
					if (auth.accessToken !== activeToken) {
						setActiveToken(auth.accessToken);
						localStorage.setItem("accessToken", auth.accessToken);
					}
				}
			} catch (error) {
				console.error("Error during token validation or refresh:", error);
				setActiveToken(null);
				localStorage.removeItem("accessToken");
			} finally {
				setIsLoading(false);
			}
		};

		validateAndRefreshToken();
	}, [auth?.accessToken, activeToken, refresh, setAuth]);

	if (isLoading) {
		return <p>Loading...</p>;
	}

	// If no valid token, redirect
	if (!activeToken) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}

export default RequiredAuth;
